.unsavedChangesNavigateChoiceButtons {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

.unsavedChangesNavigateChoiceButtonsRight {
    display: flex;
    flex-direction: row;
    gap: 8px;
}

.controlsContainer {
    display: flex;
    flex-direction: column;
    gap: 24px;
}

.assessmentWideFilesList {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.assignmentsColumn {
    display: flex;
    flex-direction: column;
    gap: 32px;
}

.assignmentsRow {
    display: flex;
    flex-direction: row;
}

.assignmentsRowElement {
    flex: 1;
}

.textAndTooltip {
    display: flex;
    flex-direction: row;
    gap: 4px;
    align-items: center;
}